/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Client } from '../models/client';
import { FactorBrokerEmailMessagePagedResult } from '../models/factor-broker-email-message-paged-result';
import { GlobalClient } from '../models/global-client';
import { LoadPagedResult } from '../models/load-paged-result';
import { monitorGetAllClientsPost } from '../fn/monitor/monitor-get-all-clients-post';
import { MonitorGetAllClientsPost$Params } from '../fn/monitor/monitor-get-all-clients-post';
import { monitorGetAllClientsPost$Plain } from '../fn/monitor/monitor-get-all-clients-post-plain';
import { MonitorGetAllClientsPost$Plain$Params } from '../fn/monitor/monitor-get-all-clients-post-plain';
import { monitorGetAllGlobalClientsGet } from '../fn/monitor/monitor-get-all-global-clients-get';
import { MonitorGetAllGlobalClientsGet$Params } from '../fn/monitor/monitor-get-all-global-clients-get';
import { monitorGetAllGlobalClientsGet$Plain } from '../fn/monitor/monitor-get-all-global-clients-get-plain';
import { MonitorGetAllGlobalClientsGet$Plain$Params } from '../fn/monitor/monitor-get-all-global-clients-get-plain';
import { monitorGetLoadsByClientLoadPost } from '../fn/monitor/monitor-get-loads-by-client-load-post';
import { MonitorGetLoadsByClientLoadPost$Params } from '../fn/monitor/monitor-get-loads-by-client-load-post';
import { monitorGetLoadsByClientLoadPost$Plain } from '../fn/monitor/monitor-get-loads-by-client-load-post-plain';
import { MonitorGetLoadsByClientLoadPost$Plain$Params } from '../fn/monitor/monitor-get-loads-by-client-load-post-plain';
import { monitorGetSubmissionSqsMessageDetailsForBrokersGet } from '../fn/monitor/monitor-get-submission-sqs-message-details-for-brokers-get';
import { MonitorGetSubmissionSqsMessageDetailsForBrokersGet$Params } from '../fn/monitor/monitor-get-submission-sqs-message-details-for-brokers-get';
import { monitorGetSubmissionSqsMessageDetailsForFactorsGet } from '../fn/monitor/monitor-get-submission-sqs-message-details-for-factors-get';
import { MonitorGetSubmissionSqsMessageDetailsForFactorsGet$Params } from '../fn/monitor/monitor-get-submission-sqs-message-details-for-factors-get';
import { monitorListIdpOutboundWithoutCompletedExportsForBrokersGet } from '../fn/monitor/monitor-list-idp-outbound-without-completed-exports-for-brokers-get';
import { MonitorListIdpOutboundWithoutCompletedExportsForBrokersGet$Params } from '../fn/monitor/monitor-list-idp-outbound-without-completed-exports-for-brokers-get';
import { monitorListIdpOutboundWithoutCompletedExportsForFactorsGet } from '../fn/monitor/monitor-list-idp-outbound-without-completed-exports-for-factors-get';
import { MonitorListIdpOutboundWithoutCompletedExportsForFactorsGet$Params } from '../fn/monitor/monitor-list-idp-outbound-without-completed-exports-for-factors-get';
import { monitorSearchEmailMessagesSearchEmailMessagesPost } from '../fn/monitor/monitor-search-email-messages-search-email-messages-post';
import { MonitorSearchEmailMessagesSearchEmailMessagesPost$Params } from '../fn/monitor/monitor-search-email-messages-search-email-messages-post';
import { monitorSearchEmailMessagesSearchEmailMessagesPost$Plain } from '../fn/monitor/monitor-search-email-messages-search-email-messages-post-plain';
import { MonitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Params } from '../fn/monitor/monitor-search-email-messages-search-email-messages-post-plain';
import { monitorSearchSqsMessagesSearchSqsMessagesPost } from '../fn/monitor/monitor-search-sqs-messages-search-sqs-messages-post';
import { MonitorSearchSqsMessagesSearchSqsMessagesPost$Params } from '../fn/monitor/monitor-search-sqs-messages-search-sqs-messages-post';
import { monitorSearchSqsMessagesSearchSqsMessagesPost$Plain } from '../fn/monitor/monitor-search-sqs-messages-search-sqs-messages-post-plain';
import { MonitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Params } from '../fn/monitor/monitor-search-sqs-messages-search-sqs-messages-post-plain';
import { monitorSearchSubmissionsSearchSubmissionsPost } from '../fn/monitor/monitor-search-submissions-search-submissions-post';
import { MonitorSearchSubmissionsSearchSubmissionsPost$Params } from '../fn/monitor/monitor-search-submissions-search-submissions-post';
import { monitorSearchSubmissionsSearchSubmissionsPost$Plain } from '../fn/monitor/monitor-search-submissions-search-submissions-post-plain';
import { MonitorSearchSubmissionsSearchSubmissionsPost$Plain$Params } from '../fn/monitor/monitor-search-submissions-search-submissions-post-plain';
import { SqsMessagePagedResult } from '../models/sqs-message-paged-result';
import { SubmissionPagedResult } from '../models/submission-paged-result';

@Injectable({ providedIn: 'root' })
export class MonitorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitorGetAllClientsPost()` */
  static readonly MonitorGetAllClientsPostPath = '/Monitor/GetAllClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetAllClientsPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllClientsPost$Plain$Response(params?: MonitorGetAllClientsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Client>>> {
    return monitorGetAllClientsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetAllClientsPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllClientsPost$Plain(params?: MonitorGetAllClientsPost$Plain$Params, context?: HttpContext): Observable<Array<Client>> {
    return this.monitorGetAllClientsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Client>>): Array<Client> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetAllClientsPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllClientsPost$Response(params?: MonitorGetAllClientsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Client>>> {
    return monitorGetAllClientsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetAllClientsPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllClientsPost(params?: MonitorGetAllClientsPost$Params, context?: HttpContext): Observable<Array<Client>> {
    return this.monitorGetAllClientsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Client>>): Array<Client> => r.body)
    );
  }

  /** Path part for operation `monitorGetAllGlobalClientsGet()` */
  static readonly MonitorGetAllGlobalClientsGetPath = '/Monitor/GetAllGlobalClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetAllGlobalClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllGlobalClientsGet$Plain$Response(params?: MonitorGetAllGlobalClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GlobalClient>>> {
    return monitorGetAllGlobalClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetAllGlobalClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllGlobalClientsGet$Plain(params?: MonitorGetAllGlobalClientsGet$Plain$Params, context?: HttpContext): Observable<Array<GlobalClient>> {
    return this.monitorGetAllGlobalClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GlobalClient>>): Array<GlobalClient> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetAllGlobalClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllGlobalClientsGet$Response(params?: MonitorGetAllGlobalClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GlobalClient>>> {
    return monitorGetAllGlobalClientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetAllGlobalClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetAllGlobalClientsGet(params?: MonitorGetAllGlobalClientsGet$Params, context?: HttpContext): Observable<Array<GlobalClient>> {
    return this.monitorGetAllGlobalClientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GlobalClient>>): Array<GlobalClient> => r.body)
    );
  }

  /** Path part for operation `monitorListIdpOutboundWithoutCompletedExportsForBrokersGet()` */
  static readonly MonitorListIdpOutboundWithoutCompletedExportsForBrokersGetPath = '/Monitor/ListIDPOutboundWithoutCompletedExportsForBrokers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorListIdpOutboundWithoutCompletedExportsForBrokersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorListIdpOutboundWithoutCompletedExportsForBrokersGet$Response(params?: MonitorListIdpOutboundWithoutCompletedExportsForBrokersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return monitorListIdpOutboundWithoutCompletedExportsForBrokersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorListIdpOutboundWithoutCompletedExportsForBrokersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorListIdpOutboundWithoutCompletedExportsForBrokersGet(params?: MonitorListIdpOutboundWithoutCompletedExportsForBrokersGet$Params, context?: HttpContext): Observable<void> {
    return this.monitorListIdpOutboundWithoutCompletedExportsForBrokersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `monitorGetSubmissionSqsMessageDetailsForBrokersGet()` */
  static readonly MonitorGetSubmissionSqsMessageDetailsForBrokersGetPath = '/Monitor/GetSubmissionSQSMessageDetailsForBrokers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetSubmissionSqsMessageDetailsForBrokersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetSubmissionSqsMessageDetailsForBrokersGet$Response(params?: MonitorGetSubmissionSqsMessageDetailsForBrokersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return monitorGetSubmissionSqsMessageDetailsForBrokersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetSubmissionSqsMessageDetailsForBrokersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetSubmissionSqsMessageDetailsForBrokersGet(params?: MonitorGetSubmissionSqsMessageDetailsForBrokersGet$Params, context?: HttpContext): Observable<void> {
    return this.monitorGetSubmissionSqsMessageDetailsForBrokersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `monitorGetSubmissionSqsMessageDetailsForFactorsGet()` */
  static readonly MonitorGetSubmissionSqsMessageDetailsForFactorsGetPath = '/Monitor/GetSubmissionSQSMessageDetailsForFactors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetSubmissionSqsMessageDetailsForFactorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetSubmissionSqsMessageDetailsForFactorsGet$Response(params?: MonitorGetSubmissionSqsMessageDetailsForFactorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return monitorGetSubmissionSqsMessageDetailsForFactorsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetSubmissionSqsMessageDetailsForFactorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetSubmissionSqsMessageDetailsForFactorsGet(params?: MonitorGetSubmissionSqsMessageDetailsForFactorsGet$Params, context?: HttpContext): Observable<void> {
    return this.monitorGetSubmissionSqsMessageDetailsForFactorsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `monitorListIdpOutboundWithoutCompletedExportsForFactorsGet()` */
  static readonly MonitorListIdpOutboundWithoutCompletedExportsForFactorsGetPath = '/Monitor/ListIDPOutboundWithoutCompletedExportsForFactors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorListIdpOutboundWithoutCompletedExportsForFactorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorListIdpOutboundWithoutCompletedExportsForFactorsGet$Response(params?: MonitorListIdpOutboundWithoutCompletedExportsForFactorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return monitorListIdpOutboundWithoutCompletedExportsForFactorsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorListIdpOutboundWithoutCompletedExportsForFactorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorListIdpOutboundWithoutCompletedExportsForFactorsGet(params?: MonitorListIdpOutboundWithoutCompletedExportsForFactorsGet$Params, context?: HttpContext): Observable<void> {
    return this.monitorListIdpOutboundWithoutCompletedExportsForFactorsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `monitorGetLoadsByClientLoadPost()` */
  static readonly MonitorGetLoadsByClientLoadPostPath = '/Monitor/GetLoadsByClientLoad';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetLoadsByClientLoadPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetLoadsByClientLoadPost$Plain$Response(params?: MonitorGetLoadsByClientLoadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadPagedResult>> {
    return monitorGetLoadsByClientLoadPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetLoadsByClientLoadPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetLoadsByClientLoadPost$Plain(params?: MonitorGetLoadsByClientLoadPost$Plain$Params, context?: HttpContext): Observable<LoadPagedResult> {
    return this.monitorGetLoadsByClientLoadPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoadPagedResult>): LoadPagedResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorGetLoadsByClientLoadPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetLoadsByClientLoadPost$Response(params?: MonitorGetLoadsByClientLoadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadPagedResult>> {
    return monitorGetLoadsByClientLoadPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorGetLoadsByClientLoadPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitorGetLoadsByClientLoadPost(params?: MonitorGetLoadsByClientLoadPost$Params, context?: HttpContext): Observable<LoadPagedResult> {
    return this.monitorGetLoadsByClientLoadPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoadPagedResult>): LoadPagedResult => r.body)
    );
  }

  /** Path part for operation `monitorSearchEmailMessagesSearchEmailMessagesPost()` */
  static readonly MonitorSearchEmailMessagesSearchEmailMessagesPostPath = '/Monitor/SearchEmailMessages/search-email-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorSearchEmailMessagesSearchEmailMessagesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Response(params?: MonitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<FactorBrokerEmailMessagePagedResult>> {
    return monitorSearchEmailMessagesSearchEmailMessagesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchEmailMessagesSearchEmailMessagesPost$Plain(params?: MonitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Params, context?: HttpContext): Observable<FactorBrokerEmailMessagePagedResult> {
    return this.monitorSearchEmailMessagesSearchEmailMessagesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<FactorBrokerEmailMessagePagedResult>): FactorBrokerEmailMessagePagedResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorSearchEmailMessagesSearchEmailMessagesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchEmailMessagesSearchEmailMessagesPost$Response(params?: MonitorSearchEmailMessagesSearchEmailMessagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FactorBrokerEmailMessagePagedResult>> {
    return monitorSearchEmailMessagesSearchEmailMessagesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorSearchEmailMessagesSearchEmailMessagesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchEmailMessagesSearchEmailMessagesPost(params?: MonitorSearchEmailMessagesSearchEmailMessagesPost$Params, context?: HttpContext): Observable<FactorBrokerEmailMessagePagedResult> {
    return this.monitorSearchEmailMessagesSearchEmailMessagesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FactorBrokerEmailMessagePagedResult>): FactorBrokerEmailMessagePagedResult => r.body)
    );
  }

  /** Path part for operation `monitorSearchSqsMessagesSearchSqsMessagesPost()` */
  static readonly MonitorSearchSqsMessagesSearchSqsMessagesPostPath = '/Monitor/SearchSqsMessages/search-sqs-messages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorSearchSqsMessagesSearchSqsMessagesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Response(params?: MonitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SqsMessagePagedResult>> {
    return monitorSearchSqsMessagesSearchSqsMessagesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSqsMessagesSearchSqsMessagesPost$Plain(params?: MonitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Params, context?: HttpContext): Observable<SqsMessagePagedResult> {
    return this.monitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SqsMessagePagedResult>): SqsMessagePagedResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorSearchSqsMessagesSearchSqsMessagesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSqsMessagesSearchSqsMessagesPost$Response(params?: MonitorSearchSqsMessagesSearchSqsMessagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SqsMessagePagedResult>> {
    return monitorSearchSqsMessagesSearchSqsMessagesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorSearchSqsMessagesSearchSqsMessagesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSqsMessagesSearchSqsMessagesPost(params?: MonitorSearchSqsMessagesSearchSqsMessagesPost$Params, context?: HttpContext): Observable<SqsMessagePagedResult> {
    return this.monitorSearchSqsMessagesSearchSqsMessagesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SqsMessagePagedResult>): SqsMessagePagedResult => r.body)
    );
  }

  /** Path part for operation `monitorSearchSubmissionsSearchSubmissionsPost()` */
  static readonly MonitorSearchSubmissionsSearchSubmissionsPostPath = '/Monitor/SearchSubmissions/search-submissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorSearchSubmissionsSearchSubmissionsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSubmissionsSearchSubmissionsPost$Plain$Response(params?: MonitorSearchSubmissionsSearchSubmissionsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionPagedResult>> {
    return monitorSearchSubmissionsSearchSubmissionsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorSearchSubmissionsSearchSubmissionsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSubmissionsSearchSubmissionsPost$Plain(params?: MonitorSearchSubmissionsSearchSubmissionsPost$Plain$Params, context?: HttpContext): Observable<SubmissionPagedResult> {
    return this.monitorSearchSubmissionsSearchSubmissionsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionPagedResult>): SubmissionPagedResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitorSearchSubmissionsSearchSubmissionsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSubmissionsSearchSubmissionsPost$Response(params?: MonitorSearchSubmissionsSearchSubmissionsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionPagedResult>> {
    return monitorSearchSubmissionsSearchSubmissionsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitorSearchSubmissionsSearchSubmissionsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  monitorSearchSubmissionsSearchSubmissionsPost(params?: MonitorSearchSubmissionsSearchSubmissionsPost$Params, context?: HttpContext): Observable<SubmissionPagedResult> {
    return this.monitorSearchSubmissionsSearchSubmissionsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionPagedResult>): SubmissionPagedResult => r.body)
    );
  }

}
